import { useCommunitiesStore } from '~/entities/container/community/stores/communities'

import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'
import { useTaggable } from '~/features-shared/tags/composables/taggable'
import type { ITag, ITaggable } from '~/features-shared/tags/interfaces/tags'
import { processTagAttribute } from '~/features-shared/tags/utils/6wpanel'

export function useCommunitySettingsTags(community_uri: SUBJECT_6W_URI): ITaggable {
  const sixwURI = computed(() => community_uri)
  const taggable = useTaggable({})
  const storeCommunity = useCommunitiesStore()

  const community = computed(() => storeCommunity.getCommunityByUri(community_uri))

  const reformatTags = () => {
    if (!community.value)
      return

    const implicit = community.value?.tags6w_implicit || []
    const explicit = community.value?.tags6w || []
    const tags = processTagAttribute(community.value.subject_uri, [...implicit, ...explicit], [], 'array') as ITag[]
    taggable.setRawTags?.({
      did: 0,
      url: '',
      buildGroup: '',
      source: '',
      slice: 0,
      score: 0,
      sort: 0,
      groups: [],
      metas: [],
      tags,
    })
  }

  whenever(() => community, async () => {
    try {
      if (community.value && !community.value.tags6w)
        await storeCommunity.setCommunityExplicitTags(community_uri)
    }
    catch (err) {

    }
    reformatTags()
  }, { immediate: true })
  whenever(() => community.value?.tags6w, reformatTags)
  whenever(() => community.value?.tags6w_implicit, reformatTags)

  return {
    enableTagging: true,
    sixwURI,
    temporaryTags: [],
    tags: taggable.tags,
    tagsWithSubjectURIData: taggable.tagsWithSubjectURIData,
    tagsWithoutSubjectURIData: taggable.tagsWithoutSubjectURIData,
  }
}
